// extracted by mini-css-extract-plugin
export default {"shortcut":"styles_shortcut__LK0mH","delete":"styles_delete__E4DRZ","key":"styles_key__7coDR","shift":"styles_shift__jS0Hu"};